import { gql } from '@apollo/client';

import baseFields from '../base';

export const generalFields = `
  email
  firstName
  lastName
  role
  isVerified
  ableScanDoc
  mainLocation {
    id
    name
  }
`;

const GENERAL_FIELDS_FRAGMENT = gql`
  fragment GeneralFieldsFragment on User {
    ${baseFields}
    ${generalFields}
  }
`;

export default GENERAL_FIELDS_FRAGMENT;
